import { render, staticRenderFns } from "./VolunteerSearchView.vue?vue&type=template&id=23b6e412&scoped=true&"
import script from "./VolunteerSearchView.vue?vue&type=script&lang=ts&"
export * from "./VolunteerSearchView.vue?vue&type=script&lang=ts&"
import style0 from "./VolunteerSearchView.vue?vue&type=style&index=0&id=23b6e412&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "23b6e412",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VContainer } from 'vuetify/lib/components/VGrid';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VRow } from 'vuetify/lib/components/VGrid';
installComponents(component, {VBtn,VCol,VContainer,VIcon,VRow})
